import axios from "axios";
import { API_BASE_URL } from "../../../config";


export const getSearchMessages = async (conversationId, searchTerm) =>
{
    try
    {
        const response = await axios.get(`${API_BASE_URL}/api/Chat/SearchMessages`, {
            params: {
                conversationId,
                searchTerm,
            },
        });
        return response.data;
    } catch (error)
    {
        console.error("Error fetching SearchMessages:", error);
        throw error;
    }
};
